/**
 * State of the training gate shown in the object details panel.
 * - READY:    annotated enough — a child object can be trained.
 * - LOCKED:   short of annotations — the user must annotate first.
 */
export const TRAINING_GATE = Object.freeze({
	READY: 'ready',
	LOCKED: 'locked',
});
